<template>

    <q-slide-transition>
        <div class="post-container row justify-start" v-if="isVisible">
            <div class='full-width ellipsis'>
                <q-select
                    multiple
                    inverted
                    color="primary"
                    chips
                    v-model=mainPost
                    :options="postAllForList"
                    @input=clickMainPost2  
                    float-label="постобработка"  
                    :before="[
                        {
                            icon: 'dehaze',
                            content: true,
                            handler () {
                                showDetail = !showDetail
                            }
                        }
                    ]"
                    :after="[
                        {
                            icon: 'close',
                            content: true,
                            handler () {
                                emptyPosts();
                            }
                        }
                    ]"

                />
            </div>
                <div class="detail-container" v-if="showDetail"  key="dcontainer">
                    <table class='full-width post_table' border=0  key="dtable">
                        <tr>
                            <td width=50px align=left></td>
                            <td align=center height="10px">        
                                <div row no-wrap>
                                    <q-checkbox v-for="(p) in postList" 
                                        :key ="0+p.value"
                                        :val = "p.value"
                                        :label="p.label"
                                        v-model="postData.top"
                                        class = "h_check"
                                        @click.native="clickPost(p.value)"
                                    />
                                </div>
                            </td>   
                            <td></td>
                        </tr>
                        <tr>
                            <td width=50px align=right>
                                <q-checkbox v-for="(p) in postList" 
                                    :key ="3+p.value"
                                    :val = "p.value"
                                    :label="p.label"
                                    v-model="postData.left"
                                    class = "v_check"
                                    left-label
                                    @click.native="clickPost(p.value)"
                                />
                            </td>
                            <td style="border:1px solid gray;"></td>
                            <td  width=50px align=left valign=center>
                                <q-checkbox v-for="(p) in postList" 
                                    :key ="1+p.value"
                                    :val = "p.value"
                                    :label="p.label"
                                    v-model="postData.right"
                                    class="v_check"
                                    @click.native="clickPost(p.value)"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td align=center>        
                                <q-checkbox v-for="(p) in postList" 
                                    :key ="2+p.value"
                                    :val = "p.value"
                                    :label="p.label"
                                    v-model="postData.bottom"
                                    class="h_check"
                                    @click.native="clickPost(p.value)"
                                />
                            </td>   
                            <td></td>
                        </tr>
                    </table>
                </div>
        </div>
    </q-slide-transition>
</template>

<script>
/* eslint-disable */
export default {
    name : 'postType1',

    props : {
        fileParam : Object,
    },

    created() {
        var file = this.$store.getters.getFileById(this.fileParam.id);
        // console.log(file);
        if (file.options != undefined) {
            let opt = JSON.parse(file.options);
            if (opt.post != undefined) {
                this.postData = opt.post;
            }
        }
        this.setInitMainPost();
        // if (opt.options != null) {
        //     this.defaultData = JSON.parse(opt.options);  // инициируем начальные данные
        //     this.mainPost = this.defaultData[2];
        // }
        eventBus.$on('emptyPost', (id) => {
            if (id == this.fileParam.id) {// если это событие дл меня
               this.emptyPosts(); //чистим
            }

        });

        //нужно заполнить mainPost - т.к. это штука вспомогательная и существует только внутри компонента
        // не совсем - тогда возникнут проблемы с обработкой по площади.. т.к. ее нет в расшифровки 
        // выход - ввод массива mainPost в defaultData еще одним элементом массива - чтобы оно тоже 
        //сохранялось в базе. Чтобы решить этот вопрос минимальными затратами - mainPost -> computed

    },
    beforeDestroy () {
        eventBus.$off('emptyPost');
    },
    
    data () {
        return { 

            postData : {
                top : [],
                right : [],
                bottom : [],
                left : [],
                space : [],
            },

            showDetail : false,
            postVisible : true,
            mainParam : null,
            mainPost : [],
            defaultData : [
                'postType1',
                [
                    [], [], [], [], [], [], [], [], [], [], [], [], [], [],
                ],
                []
            ],

        }
    },

computed : {

        isVisible() {
            return this.postAllForList.length>0;
        },

        postAllForList() {
            var list = [];
            if (this.$store.getters.getAllPostTypes === undefined) return list;
            if (this.fileParam.options === undefined) return list;
            var options = this.fileParam.options != undefined ? JSON.parse(this.fileParam.options) : {};
            // var options = JSON.parse(this.fileParam.options);
            var material = this.$store.getters.getMaterialById(options.material); 
            if (material != undefined) {
                this.$store.getters.getAllPostTypes.map((value,key)=>{
                    if (material.post_types.indexOf(value.id)>-1) {    // если материал в списке - то выводим его
                        let icon_path = "/static/"+value.icon;
                        list.push({label : value.name, value:value.id, rightAvatar : icon_path});
                    }
                });
            }
            if (list.length > 0) this.postVisible = true;
            return list;
        },

        postAllList() {
            var list = [];
            if (this.$store.getters.getAllPostTypes === undefined) return list;
            var material = this.$store.getters.getMaterialById(this.materialId);
            this.$store.getters.getAllPostTypes.map((value,key)=>{
                if (material.post_types.indexOf(value.id)>-1) {    // если материал в списке - то выводим его
                    list.push({label : value.shortName, value:value.id});
                }
            });
            return list;
        },

        postList() {
            var list = [];
            if (this.$store.getters.getAllPostTypes === undefined) return list;
            this.$store.getters.getAllPostTypes.map((value,key)=>{
                if (value.region == 0) {
                    list.push({label : value.shortName, value:value.id});
                }
            });
          return list;
        }
    },

    methods : {

        setInitMainPost() {
            let all = this.$store.getters.getAllPostTypes;

            for (let i = 0; i<all.length; i++) {
                var isId = false;
                for (var key in this.postData) {
                    let index = this.postData[key].indexOf(all[i].id);
                    if (index > -1) {
                        isId = true;
                        break; // дальше проверять смысла нет
                    }
                }
                if (isId) { // значит нужно поставить галочку
                    if (this.mainPost.indexOf(all[i].id)==-1){ // галочки нет - ставим
                        this.mainPost.push(all[i].id);
                    }
                }
            }
        },


        saveParam() {
          this.$store.commit('savePostToFile', {fileId : this.fileParam.id, param : this.postData}); 
        },

        emptyPosts() {
            this.mainPost.splice(0, this.mainPost.length);
            for (var key in this.postData) {
                this.postData[key].splice(0, this.postData[key].length);
            }
            this.saveParam();
        },

        clickMainPost2(newVal) {
        
            for (let i = 0; i<this.mainPost.length; i++) {
                // нужно понять на какую часть распространяется обработка - для этого получаем его со списка обработок
                let isPerimeter = this.$store.getters.isPerimeterPostType(this.mainPost[i]);
                
                if (isPerimeter) {  // если обработка по периметру - то фигачим периметр
                    let isSet = true; // флаг что нужно выставлять галочки в допинфе
                    for (var key in this.postData) {
                        if (this.postData[key].indexOf(this.mainPost[i]) >-1) {
                            isSet = false;
                        }
                    }
                    if (isSet) {// если таких галочек не было по сторонам - значит надо их поставить все
                        for (var key in this.postData) {
                            if (key != 'space') this.postData[key].push(this.mainPost[i]); // если это не по площади
                        }
                    }
                } else { //если обработка по площади - фигачим площадь
                    this.postData.space.push(this.mainPost[i]);
                }
                
            }
            // получаем все материалы
            let all = this.$store.getters.getAllPostTypes;
            for (let i = 0; i<all.length; i++) {
                let main_pos = this.mainPost.indexOf(all[i].id);
                for (var key in this.postData) {
                    let sidePose = this.postData[key].indexOf(all[i].id);
                    if ((main_pos==-1)&&(sidePose>-1)) { // если в майне нет такой галочки - а на стороне есть - то на стороне трем 
                        this.postData[key].splice(sidePose, 1);
                    }
                }
            }
            this.saveParam();
        },

        showData() {
           // console.log(this.defaultData);
        },

    

        clickPost(id) {
            // проверяем наличие ид на всех сторонах
            var isId = false; // по умолчанию нет его

            for (var key in this.postData) {
                let index = this.postData[key].indexOf(id);
                if (index > -1) {
                    isId = true;
                    break; // дальше проверять смысла нет
                }
            }
          
            if (isId) { // значит нужно поставить галочку
                if (this.mainPost.indexOf(id)==-1){ // галочки нет - ставим
                    this.mainPost.push(id);
                }
            } else { // надо убрать галочку
                let index = this.mainPost.indexOf(id);
                if (index>-1) {
                    this.mainPost.splice(index, 1);
                }
            }
            this.saveParam();
        },
    },

}

</script>

<style lang="scss" scoped>
    
    .post-container {
       // text-align : center;
        width : 100%;
       
        // margin: auto;
    }

    .h_check {
        margin-right : 10px;
        font-size : 13px;
        margin-top:5px;
        margin-bottom : 5px;
    }
    .v_check {
        margin-bottom: 5px;
        margin-left:5px;
        margin-right:5px;
        font-size : 13px;
    }
    .post_table {
        margin-top : 20px;
        text-align: center;
        margin: auto;
    }
    .main-post {
        background: #FFED00;
        width : 480px;
        margin: auto;
        border-radius: 45px;
        border: 1px solid #FCBF00;
        overflow: hidden;
        // display: flex;
       // justify-content: stretch;  
    }
   
    .post-title {
        float: left;
        background: #FCBF00;
        width : 75px;
        height:35px;
        line-height: 35px;
        margin: auto;
        text-transform: uppercase;
        font-size : 12px;
        font-weight: bold;
        border-right:1px solid #FCBF00;
    }
    .detail-container {
        background : rgb(243, 243, 243);
        width : 450px;
        border-radius: 0 0 15px 15px;
        border : 1px solid rgb(211, 211, 211);
        border-top: 0px;
        padding : 5px;
    }
    .expand-button {
        margin-left: 30px;
    }
    .post_input{
        width : 450px;
        margin : auto;
        padding-bottom: 10px;
        text-align: left;
    }
</style>
